import React from "react";
import { useNavigate } from "react-router-dom";
import { useActivityLogger } from "./hooks/useActivity";

const platforms = [
  {
    name: "halodoc",
    logo: "/logo-halodoc.png",
    androidUrl: "https://play.google.com/store/apps/details?id=com.linkdokter.halodoc.android",
    iosUrl: "https://apps.apple.com/id/app/halodoc-dokter-obat/id1016291105",
    appLink: "halodoc://home", // deep link jika app terinstall
  },
  {
    name: "alodokter",
    logo: "/logo-alodokter.png",
    androidUrl: "https://play.google.com/store/apps/details?id=com.alodokter.android",
    iosUrl: "https://apps.apple.com/id/app/alodokter/id975022341",
    appLink: "alodokter://home",
  },
  {
    name: "klikdokter",
    logo: "/logo-klikdokter.png",
    androidUrl: "https://play.google.com/store/apps/details?id=id.codigo.klikdokter",
    iosUrl: "https://apps.apple.com/id/app/klikdokter/id988034731",
    appLink: "klikdokter://home",
  },
  {
    name: "dkonsul",
    logo: "/logo-dkonsul.png",
    androidUrl: "https://www.dkonsul.com/",
    iosUrl: "https://www.dkonsul.com/",
    appLink: "dkonsul://home",
  },
];

export default function Telekonsultasi() {
  const navigate = useNavigate();
  const { logUserActivity } = useActivityLogger();

  const getOS = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) return "Android";
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS";
    return "Other";
  };

  const handleRedirect = (platform) => {
    const os = getOS();
    logUserActivity(
      "user",
      "telekonsultasi_redirect",
      "Telekonsultasi",
      `User redirected to ${platform.name} (${os})`
    );

    // Coba buka aplikasi langsung
    if (platform.appLink) {
      window.location.href = platform.appLink;
    }

    // Kalau gagal (app tidak terpasang), arahkan ke store
    setTimeout(() => {
      if (os === "Android") {
        window.open(platform.androidUrl, "_blank");
      } else if (os === "iOS") {
        window.open(platform.iosUrl, "_blank");
      } else {
        window.open(platform.androidUrl, "_blank"); // default ke Android
      }
    }, 500);
  };

  return (
    <div className="min-h-screen bg-white px-4 py-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <button
          onClick={() => {
            logUserActivity(
              "user",
              "go_back_from_telekonsultasi",
              "Telekonsultasi",
              "User navigated back from telekonsultasi page"
            );
            navigate("/");
          }}
        >
          <img src="/icon-back.png" alt="Back" className="h-6 w-6" />
        </button>
        <h1 className="text-lg font-semibold">Telekonsultasi</h1>
        <div className="w-6 h-6" /> {/* spacer */}
      </div>

      {/* List */}
      <div className="space-y-3">
        {platforms.map((item, index) => (
          <button
            key={index}
            onClick={() => handleRedirect(item)}
            className="w-full flex items-center justify-between px-4 py-3 border rounded-full shadow-sm hover:bg-gray-50 transition"
          >
            <img src={item.logo} alt={item.name} className="w-24" />
            <img
              src="/icon-chevron-right.png"
              alt="Next"
              className="h-5 w-5 opacity-60"
            />
          </button>
        ))}
      </div>
    </div>
  );
}
